
export interface Card {
    code: string,
    image: string,
    images: object,
    value: string,
    suit: string
}

export const cardsList = [
    {
      "code": "4H",
      "image": "./images/4H.png",
      "images": {
        "svg": "./images/4H.svg",
        "png": "./images/4H.png"
      },
      "value": "4",
      "suit": "HEARTS"
    },
    {
      "code": "0C",
      "image": "./images/0C.png",
      "images": {
        "svg": "./images/0C.svg",
        "png": "./images/0C.png"
      },
      "value": "10",
      "suit": "CLUBS"
    },
    {
      "code": "4C",
      "image": "./images/4C.png",
      "images": {
        "svg": "./images/4C.svg",
        "png": "./images/4C.png"
      },
      "value": "4",
      "suit": "CLUBS"
    },
    {
      "code": "AD",
      "image": "./images/aceDiamonds.png",
      "images": {
        "svg": "./images/aceDiamonds.svg",
        "png": "./images/aceDiamonds.png"
      },
      "value": "ACE",
      "suit": "DIAMONDS"
    },
    {
      "code": "JS",
      "image": "./images/JS.png",
      "images": {
        "svg": "./images/JS.svg",
        "png": "./images/JS.png"
      },
      "value": "JACK",
      "suit": "SPADES"
    },
    {
      "code": "JD",
      "image": "./images/JD.png",
      "images": {
        "svg": "./images/JD.svg",
        "png": "./images/JD.png"
      },
      "value": "JACK",
      "suit": "DIAMONDS"
    },
    {
      "code": "6S",
      "image": "./images/6S.png",
      "images": {
        "svg": "./images/6S.svg",
        "png": "./images/6S.png"
      },
      "value": "6",
      "suit": "SPADES"
    },
    {
      "code": "2H",
      "image": "./images/2H.png",
      "images": {
        "svg": "./images/2H.svg",
        "png": "./images/2H.png"
      },
      "value": "2",
      "suit": "HEARTS"
    },
    {
      "code": "3D",
      "image": "./images/3D.png",
      "images": {
        "svg": "./images/3D.svg",
        "png": "./images/3D.png"
      },
      "value": "3",
      "suit": "DIAMONDS"
    },
    {
      "code": "JC",
      "image": "./images/JC.png",
      "images": {
        "svg": "./images/JC.svg",
        "png": "./images/JC.png"
      },
      "value": "JACK",
      "suit": "CLUBS"
    },
    {
      "code": "5H",
      "image": "./images/5H.png",
      "images": {
        "svg": "./images/5H.svg",
        "png": "./images/5H.png"
      },
      "value": "5",
      "suit": "HEARTS"
    },
    {
      "code": "4S",
      "image": "./images/4S.png",
      "images": {
        "svg": "./images/4S.svg",
        "png": "./images/4S.png"
      },
      "value": "4",
      "suit": "SPADES"
    },
    {
      "code": "8H",
      "image": "./images/8H.png",
      "images": {
        "svg": "./images/8H.svg",
        "png": "./images/8H.png"
      },
      "value": "8",
      "suit": "HEARTS"
    },
    {
      "code": "7D",
      "image": "./images/7D.png",
      "images": {
        "svg": "./images/7D.svg",
        "png": "./images/7D.png"
      },
      "value": "7",
      "suit": "DIAMONDS"
    },
    {
      "code": "QS",
      "image": "./images/QS.png",
      "images": {
        "svg": "./images/QS.svg",
        "png": "./images/QS.png"
      },
      "value": "QUEEN",
      "suit": "SPADES"
    },
    {
      "code": "7C",
      "image": "./images/7C.png",
      "images": {
        "svg": "./images/7C.svg",
        "png": "./images/7C.png"
      },
      "value": "7",
      "suit": "CLUBS"
    },
    {
      "code": "8C",
      "image": "./images/8C.png",
      "images": {
        "svg": "./images/8C.svg",
        "png": "./images/8C.png"
      },
      "value": "8",
      "suit": "CLUBS"
    },
    {
      "code": "JH",
      "image": "./images/JH.png",
      "images": {
        "svg": "./images/JH.svg",
        "png": "./images/JH.png"
      },
      "value": "JACK",
      "suit": "HEARTS"
    },
    {
      "code": "2C",
      "image": "./images/2C.png",
      "images": {
        "svg": "./images/2C.svg",
        "png": "./images/2C.png"
      },
      "value": "2",
      "suit": "CLUBS"
    },
    {
      "code": "QC",
      "image": "./images/QC.png",
      "images": {
        "svg": "./images/QC.svg",
        "png": "./images/QC.png"
      },
      "value": "QUEEN",
      "suit": "CLUBS"
    },
    {
      "code": "6C",
      "image": "./images/6C.png",
      "images": {
        "svg": "./images/6C.svg",
        "png": "./images/6C.png"
      },
      "value": "6",
      "suit": "CLUBS"
    },
    {
      "code": "KH",
      "image": "./images/KH.png",
      "images": {
        "svg": "./images/KH.svg",
        "png": "./images/KH.png"
      },
      "value": "KING",
      "suit": "HEARTS"
    },
    {
      "code": "5C",
      "image": "./images/5C.png",
      "images": {
        "svg": "./images/5C.svg",
        "png": "./images/5C.png"
      },
      "value": "5",
      "suit": "CLUBS"
    },
    {
      "code": "QH",
      "image": "./images/QH.png",
      "images": {
        "svg": "./images/QH.svg",
        "png": "./images/QH.png"
      },
      "value": "QUEEN",
      "suit": "HEARTS"
    },
    {
      "code": "AS",
      "image": "./images/AS.png",
      "images": {
        "svg": "./images/AS.svg",
        "png": "./images/AS.png"
      },
      "value": "ACE",
      "suit": "SPADES"
    },
    {
      "code": "KS",
      "image": "./images/KS.png",
      "images": {
        "svg": "./images/KS.svg",
        "png": "./images/KS.png"
      },
      "value": "KING",
      "suit": "SPADES"
    },
    {
      "code": "7H",
      "image": "./images/7H.png",
      "images": {
        "svg": "./images/7H.svg",
        "png": "./images/7H.png"
      },
      "value": "7",
      "suit": "HEARTS"
    },
    {
      "code": "4D",
      "image": "./images/4D.png",
      "images": {
        "svg": "./images/4D.svg",
        "png": "./images/4D.png"
      },
      "value": "4",
      "suit": "DIAMONDS"
    },
    {
      "code": "0S",
      "image": "./images/0S.png",
      "images": {
        "svg": "./images/0S.svg",
        "png": "./images/0S.png"
      },
      "value": "10",
      "suit": "SPADES"
    },
    {
      "code": "8S",
      "image": "./images/8S.png",
      "images": {
        "svg": "./images/8S.svg",
        "png": "./images/8S.png"
      },
      "value": "8",
      "suit": "SPADES"
    },
    {
      "code": "8D",
      "image": "./images/8D.png",
      "images": {
        "svg": "./images/8D.svg",
        "png": "./images/8D.png"
      },
      "value": "8",
      "suit": "DIAMONDS"
    },
    {
      "code": "AH",
      "image": "./images/AH.png",
      "images": {
        "svg": "./images/AH.svg",
        "png": "./images/AH.png"
      },
      "value": "ACE",
      "suit": "HEARTS"
    },
    {
      "code": "6D",
      "image": "./images/6D.png",
      "images": {
        "svg": "./images/6D.svg",
        "png": "./images/6D.png"
      },
      "value": "6",
      "suit": "DIAMONDS"
    },
    {
      "code": "KD",
      "image": "./images/KD.png",
      "images": {
        "svg": "./images/KD.svg",
        "png": "./images/KD.png"
      },
      "value": "KING",
      "suit": "DIAMONDS"
    },
    {
      "code": "3C",
      "image": "./images/3C.png",
      "images": {
        "svg": "./images/3C.svg",
        "png": "./images/3C.png"
      },
      "value": "3",
      "suit": "CLUBS"
    },
    {
      "code": "3S",
      "image": "./images/3S.png",
      "images": {
        "svg": "./images/3S.svg",
        "png": "./images/3S.png"
      },
      "value": "3",
      "suit": "SPADES"
    },
    {
      "code": "0H",
      "image": "./images/0H.png",
      "images": {
        "svg": "./images/0H.svg",
        "png": "./images/0H.png"
      },
      "value": "10",
      "suit": "HEARTS"
    },
    {
      "code": "7S",
      "image": "./images/7S.png",
      "images": {
        "svg": "./images/7S.svg",
        "png": "./images/7S.png"
      },
      "value": "7",
      "suit": "SPADES"
    },
    {
      "code": "6H",
      "image": "./images/6H.png",
      "images": {
        "svg": "./images/6H.svg",
        "png": "./images/6H.png"
      },
      "value": "6",
      "suit": "HEARTS"
    },
    {
      "code": "AC",
      "image": "./images/AC.png",
      "images": {
        "svg": "./images/AC.svg",
        "png": "./images/AC.png"
      },
      "value": "ACE",
      "suit": "CLUBS"
    },
    {
      "code": "2S",
      "image": "./images/2S.png",
      "images": {
        "svg": "./images/2S.svg",
        "png": "./images/2S.png"
      },
      "value": "2",
      "suit": "SPADES"
    },
    {
      "code": "9D",
      "image": "./images/9D.png",
      "images": {
        "svg": "./images/9D.svg",
        "png": "./images/9D.png"
      },
      "value": "9",
      "suit": "DIAMONDS"
    },
    {
      "code": "5S",
      "image": "./images/5S.png",
      "images": {
        "svg": "./images/5S.svg",
        "png": "./images/5S.png"
      },
      "value": "5",
      "suit": "SPADES"
    },
    {
      "code": "0D",
      "image": "./images/0D.png",
      "images": {
        "svg": "./images/0D.svg",
        "png": "./images/0D.png"
      },
      "value": "10",
      "suit": "DIAMONDS"
    },
    {
      "code": "9S",
      "image": "./images/9S.png",
      "images": {
        "svg": "./images/9S.svg",
        "png": "./images/9S.png"
      },
      "value": "9",
      "suit": "SPADES"
    },
    {
      "code": "2D",
      "image": "./images/2D.png",
      "images": {
        "svg": "./images/2D.svg",
        "png": "./images/2D.png"
      },
      "value": "2",
      "suit": "DIAMONDS"
    },
    {
      "code": "QD",
      "image": "./images/QD.png",
      "images": {
        "svg": "./images/QD.svg",
        "png": "./images/QD.png"
      },
      "value": "QUEEN",
      "suit": "DIAMONDS"
    },
    {
      "code": "KC",
      "image": "./images/KC.png",
      "images": {
        "svg": "./images/KC.svg",
        "png": "./images/KC.png"
      },
      "value": "KING",
      "suit": "CLUBS"
    },
    {
      "code": "9H",
      "image": "./images/9H.png",
      "images": {
        "svg": "./images/9H.svg",
        "png": "./images/9H.png"
      },
      "value": "9",
      "suit": "HEARTS"
    },
    {
      "code": "9C",
      "image": "./images/9C.png",
      "images": {
        "svg": "./images/9C.svg",
        "png": "./images/9C.png"
      },
      "value": "9",
      "suit": "CLUBS"
    },
    {
      "code": "3H",
      "image": "./images/3H.png",
      "images": {
        "svg": "./images/3H.svg",
        "png": "./images/3H.png"
      },
      "value": "3",
      "suit": "HEARTS"
    },
    {
      "code": "5D",
      "image": "./images/5D.png",
      "images": {
        "svg": "./images/5D.svg",
        "png": "./images/5D.png"
      },
      "value": "5",
      "suit": "DIAMONDS"
    }
  ]